export const TRUELAYER_SUCCESS = 'success';
export const TRUELAYER_FAILURE = 'failure';
export const TRUELAYER_CANCEL = 'cancel';
